import { render, staticRenderFns } from "./Account_BaseRegistration.vue?vue&type=template&id=74f04836&"
import script from "./Account_BaseRegistration.vue?vue&type=script&lang=js&"
export * from "./Account_BaseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./Account_BaseRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports